import React from "react";
import { getAppThemeMode } from "theme/appTheme.js";

const FONT_SIZE = 18.0;

// eslint-disable-next-line react/prop-types
const LCD = ({ backlit, lines, width, height, className, style }) => {
  const isDark = getAppThemeMode() === "dark";
  const bgcolor = !backlit
    ? "#0a0a0a"
    : isDark
      ? "#141a24"
      : "#1111ff";
  const textFill = isDark ? "#80a3ff" : "#2fa4f6";
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      className: ["LCD", className].filter(Boolean).join(" "),
      viewBox: "0 0 78 32",
      width: width,
      height: height,
      style: style,
    },
    /*#__PURE__*/ React.createElement(
      "defs",
      null,
      /*#__PURE__*/ React.createElement(
        "lineargradient",
        {
          id: "c",
          x1: "417.79",
          x2: "458.73",
          y1: "103.78",
          y2: "142.81",
          gradientTransform: "translate(-401.72 -103.94)",
          gradientUnits: "userSpaceOnUse",
          xlinkHref: "#a",
        },
        /*#__PURE__*/ React.createElement(
          "lineargradient",
          {
            id: "a",
          },
          /*#__PURE__*/ React.createElement("stop", {
            offset: "0",
            stopColor: "#454545",
          }),
          /*#__PURE__*/ React.createElement("stop", {
            offset: "1",
            stopColor: "#646464",
            stopOpacity: ".3",
          }),
        ),
      ),
    ),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#333",
      stroke: "url(#a)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".28",
      d: "M3.55 3.19h77.89V34.9H3.55z",
      transform: "translate(-3.41 -3.05)",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#161616",
      stroke: "url(#a)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".26",
      d: "M5.12 4.33h74.96v29.31H5.12z",
      transform: "translate(-3.41 -3.05)",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#333",
      stroke: "#646464",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: ".3",
      strokeWidth: ".28",
      d: "M7.51 6.95h70.34v24.42H7.51z",
      transform: "translate(-3.41 -3.05)",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: bgcolor,
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: ".3",
      strokeWidth: ".28",
      d: "M8.76 8.3h67.73v21.6H8.76z",
      transform: "translate(-3.41 -3.05)",
    }),
    /*#__PURE__*/
    lines &&
      lines.map((line, idx) =>
        React.createElement(
          "text",
          {
            fill: textFill,
            x: "11",
            y: 13 + (FONT_SIZE / lines.length) * idx,
            fontFamily: "HD44780",
            fontSize: FONT_SIZE / lines.length,
            transform: "translate(-3.41 -3.05)",
            style: {
              whiteSpace: "pre",
            },
          },
          line,
        ),
      ),
  );
};

export default LCD;
